import SearchIcon from "@mui/icons-material/Search";
import { tableToolStyles } from "../tableStyles/styles";
import { useState, useEffect } from "react";

const TableSearch = ({ onChange }) => {
  const [search, setSearch] = useState("");

  // Debounce: wait for user to stop typing
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      onChange(search); // send value to parent
    }, 500); // 500ms delay

    return () => clearTimeout(delayDebounce); // cleanup
  }, [search]);

  const handleTableSearch = (event) => {
    setSearch(event.target.value);
  };

  return (
    <div style={{ ...tableToolStyles.search.box }}>
      <input
        value={search}
        onChange={handleTableSearch}
        placeholder="Search..."
        style={{ ...tableToolStyles.search.input }}
      />
      <SearchIcon sx={{ ...tableToolStyles.search.icon }} />
    </div>
  );
};

export default TableSearch;
